import $ from 'jquery'
import ChessBoard from '../components/chessBoard'
import Card from '../components/card'
import {
  CAPTURED_PIECE_COLOR_MAPPER,
  BLACK_PIECE,
  ACTIVITY_SUCCESS_AUDIO,
  ACTIVITY_COMPLETION_AUDIO,
  CORRECT_ANSWER_AUDIO,
  WRONG_ANSWER_AUDIO
} from './constants'

var pieceWidth, pieceHeight;
var captureCount = 0;

/**
* @name createChessboard 
* @function
* @param {config}
* @description: Create chessboard
*/
export function createChessboard(config) {
  let afterLoad = function () {
    prepareChessboard(config);
  }
  const chessConfig = {
    config: {
      position: config.position,
    },
    afterLoad: afterLoad
  }
  return chessConfig;
}

/**
* @name prepareChessboard 
* @function
* @param {config}
* @description: prepare initial Chessboard
*/
export function prepareChessboard(config) {
  let piecesArray = config.piecesArray,
    showIndicators = config.showIndicators,
    singleSpare = config.singleSpare,
    position = config.position,
    sparePieces = $('.spare-pieces-7492f'),
    leftSparePieces = $('.spare-pieces-top-4028b'),
    rightSparePieces = $('.spare-pieces-bottom-ae20f'),
    styleClasses = 'assignment ' + config.assignmentClass;

  sparePieces.css('padding', '0');
  styleClasses = styleClasses + (showIndicators ? (showIndicators.allSides ? ' indicators all-sides ' : ' indicators ') : '');
  $('#chessBoard').addClass(styleClasses);

  if (singleSpare) {
    let styleClass = (position === 'right') ? 'sparepieces_container_right' : 'sparepieces_container_left';

    $('#chessBoard').append(`<div class='sparepieces_container ${styleClass}'></div>`)
    $('.sparepieces_container').append(sparePieces);
  } else {
    $('#chessBoard').append("<div class='sparepieces_container sparepieces_container_left'></div>")
    $('.sparepieces_container_left').append(leftSparePieces);
    $('#chessBoard').append("<div class='sparepieces_container sparepieces_container_right'></div>")
    $('.sparepieces_container_right').append(rightSparePieces);
  }

  piecesArray && piecesArray.map(function (piece) {
    return $(".sparepieces_container img[data-piece = " + piece + "]").css("display", "block");
  })

  $('.sparepieces_container img').css('visibility', 'visible')

}

/**
* @name updatePieces
* @function
* @param {piece, count, limit, onDrop}
* @description: Update the piece position on the board
*/
export function updatePieces(piece, count, limit, onDrop = false) {
  if (count === (limit - 1)) {
    $(".sparepieces_container img[data-piece = " + piece + "]").css("visibility", "hidden");
  } else {
    if (onDrop) {
      $(".sparepieces_container img[data-piece = " + piece + "]").css("visibility", "visible");
    }
  }
}

/**
* @name validateDrag
* @function
* @param {piece, count, limit, onDrop}
* @description: Update the piece position on the board
*/
export function validateDrag(piece, limit) {
  let pieceCount = $(".board-b72b1 img[data-piece = " + piece + "]").length;

  updatePieces(piece, pieceCount, limit);
}

/**
* @name validateDrop
* @function
* @param {piece, count, limit, onDrop}
* @description: Update the piece position on the board
*/
export function validateDrop(piece, limit, target, validatePieces, celebrationSound) {
  setTimeout(function () {
    let pieceCount = $(".board-b72b1 img[data-piece = " + piece + "]").length;
    
    updatePieces(piece, pieceCount - 1, limit, true);
  }, 100)
  if (validatePieces[piece].filter(f => f === target).length === 0) {
    if (celebrationSound) {
      $(document).trigger("audio-play", WRONG_ANSWER_AUDIO)
    }
    $(".sparepieces_container img[data-piece = " + piece + "]").css("visibility", "visible");
    return 'trash';
  } else {
    if (celebrationSound) {
      $(document).trigger("audio-play", CORRECT_ANSWER_AUDIO)
    }
  }
}

/**
* @name validatePosition
* @function
* @param {}
* @description: Validate the assignment and navigate
*/
export function validatePosition(pieceLimit, resultFen, next, bubbleConfig = null, isQA = false, celebrationSound) {
  if ($(".piece-417db").length >= (12 + pieceLimit)) {
    setTimeout(function () {
      let fen = ChessBoard.board.fen()

      if (fen === resultFen) {
        if (celebrationSound) {
          $(document).trigger('audio-play', ACTIVITY_SUCCESS_AUDIO);
        }
        if (isQA) {
          Card.result = Card.result + 1;
        }
        if (bubbleConfig) {
          showMagnus(bubbleConfig)
          loadNextConfiguration(4000, next, celebrationSound)
        } else {
          loadNextConfiguration(2000, next, celebrationSound)
        }
      }
    }, 100)
  }
}

/**
* @name validateCoordinates
* @function
* @param {}
* @description: Validate the Coordinates
*/
export function validateCoordinates(coordinate, next, coordinateCount, bubbleConfig = null, isQA = false, completionAudio) {
  completionAudio = (completionAudio === false) ? completionAudio : true;
  if ($('#chessBoard').find('.' + coordinate).length === coordinateCount) {
    $(document).trigger('clear-timer');
    
    if (isQA) {
      Card.result = Card.result + 1;
    }

    if (bubbleConfig) {
      showMagnus(bubbleConfig)
      loadNextConfiguration(4000, next, completionAudio)
    } else {
      loadNextConfiguration(2000, next, completionAudio)
    }
  }
}

/**
* @name loadNextConfiguration
* @function
* @param {timeout}
* @description: Load next configuration
*/
export function loadNextConfiguration(timeout, next, completionAudio) {
  if (completionAudio) {
    $(document).trigger('audio-play', ACTIVITY_COMPLETION_AUDIO);
  }
  setTimeout(function () {
    $(document).trigger('next-config', next);
  }, timeout)
}

/**
* @name showMagnus
* @function
* @param {config}
* @description: Show Magnus
*/
export function showMagnus(config) {
  let bubbleConfig = (typeof config) === 'string' ? { text: config } : config;

  $(document).trigger('bubble-show', bubbleConfig);
}

/**
* @name showReminder
* @function
* @param {remainingCount}
* @description: Show reminder
*/
export function showReminder(remainingCount) {
  // $(document).trigger('clear-timer');
  $(document).trigger('bubble-hide');
  
  showMagnus({
    data: `Keep going... <br/> ${remainingCount} more to go`,
    position: 'left',
    styleClass: 'xs',
    timeout: 5000
  })
}

/**
* @name validateMove
* @function
* @param {source, target}
* @description: Validate chess piece Move
*/
export function validateMove(source, target, piece, showCaptured = false) {
  let move = ChessBoard.game.move({
    from: source,
    to: target
  });
  if (move === null) {
    return 'snapback';
  } else {
    if (move.captured && showCaptured) {
      showCapturedPieces(piece, move)
    }
  }
}

/**
* @name restrictMove
* @function
* @param {piece}
* @description: Allow only move black or white piece
*/
export function restrictMove(piece, p) {
  if (piece.search(p) !== -1) {
    return false;
  }
}

/**
* @name showCapturedPieces
* @function
* @param {piece, move}
* @description: Show Captured Pieces
*/
export function showCapturedPieces(piece, move, showLeft = true) {
  let captured = move.captured,
    capturedPieceColor = CAPTURED_PIECE_COLOR_MAPPER[move.color],
    capturedPiece = capturedPieceColor + captured.toUpperCase(),
    spareContainerClass = '';

  if (move.color === BLACK_PIECE || showLeft) {
    spareContainerClass = '.spare-pieces-bottom-ae20f';
  } else {
    spareContainerClass = '.spare-pieces-top-4028b';
  }

  let el = $(spareContainerClass + ' img')[captureCount]

  if (el) {
    pieceWidth = $(el).width()
    pieceHeight = $(el).height()
    $(el).attr({ 'src': 'img/chesspieces/simple_black_white/' + capturedPiece + '.svg', 'data-piece': capturedPiece });
    $(el).css({ 'visibility': 'visible', 'display': 'block' })
  } else {
    let p = `<img src="img/chesspieces/simple_black_white/${capturedPiece}.svg" class="piece-417db" data-piece=${capturedPiece} style="width: ${pieceWidth}px; height: ${pieceHeight}px; visibility: visible; display: block;">`
    $(spareContainerClass).append(p)
  }

  captureCount++;
}

/**
* @name hideCapturedPieces
* @function
* @param {}
* @description: Hide Captured Pieces
*/
export function hideCapturedPieces() {
  captureCount = 0;
  $('.spare-pieces-7492f img').css('visibility', 'hidden');
}

/**
* @name plotArrow
* @function
* @param {ctx, source, target, sourceOffset, targetOffset, arrowHeadWidth, arrowTailWidth}
* @description: Plots an arrow on canvas
*/
export function plotArrow(ctx, fromClass, toClass, offsetFromx, offsetFromy, offsetTox, offsetToy, arrowHead, arrowTail, arrowColor) {

  let fromA = document.getElementsByClassName("square-a1"),
    fromAx = fromA[0].offsetParent.offsetLeft + fromA[0].offsetLeft,
    toB = document.getElementsByClassName("square-b1"),
    toBx = toB[0].offsetParent.offsetLeft + toB[0].offsetLeft;

  let squareEdge = toBx - fromAx;
  let offset = squareEdge / 2;

  offsetFromx = offsetFromx ? ((offsetFromx/10)*squareEdge) : offset;
  offsetFromy = offsetFromy ? ((offsetFromy/10)*squareEdge) : offset;
  offsetTox = offsetTox ? ((offsetTox/10)*squareEdge) : offset;
  offsetToy = offsetToy ? ((offsetToy/10)*squareEdge) : offset;
  arrowHead = (arrowHead || arrowHead === 0) ? arrowHead : squareEdge / 9;
  arrowTail = arrowTail ? arrowTail : squareEdge / 8;
  arrowColor = arrowColor ? arrowColor : "#F2A455";

  let from = document.getElementsByClassName(fromClass),
    fromx = from[0].offsetParent.offsetLeft + from[0].offsetLeft + offsetFromx,
    fromy = from[0].offsetParent.offsetTop + from[0].offsetTop + offsetFromy,
    to = document.getElementsByClassName(toClass),
    tox = to[0].offsetParent.offsetLeft + to[0].offsetLeft + offsetTox,
    toy = to[0].offsetParent.offsetTop + to[0].offsetTop + offsetToy,
    headlen = arrowHead,
    angle = Math.atan2(toy - fromy, tox - fromx);

  ctx.beginPath();
  ctx.moveTo(fromx, fromy);
  ctx.lineTo(tox, toy);
  ctx.strokeStyle = arrowColor;
  ctx.lineWidth = arrowTail;
  ctx.stroke();

  //starting a new path from the head of the arrow to one of the sides of the point
  ctx.beginPath();
  ctx.moveTo(tox, toy);
  ctx.lineTo(tox - headlen * Math.cos(angle - Math.PI / 7), toy - headlen * Math.sin(angle - Math.PI / 7));

  //path from the side point of the arrow, to the other side point
  ctx.lineTo(tox - headlen * Math.cos(angle + Math.PI / 7), toy - headlen * Math.sin(angle + Math.PI / 7));

  //path from the side point back to the tip of the arrow, and then again to the opposite side point
  ctx.lineTo(tox, toy);
  ctx.lineTo(tox - headlen * Math.cos(angle - Math.PI / 7), toy - headlen * Math.sin(angle - Math.PI / 7));

  //draws the paths created above
  ctx.strokeStyle = arrowColor;
  ctx.lineWidth = arrowHead;
  ctx.stroke();
  ctx.fillStyle = arrowColor;
  ctx.fill();
}

/**
* @name getSubstring
* @function
* @param {from, to}
* @description: To get the substring from the 'from' and 'to' coordinates
*/
export function getSubstring(from, to){
  let fromFinal = from.substr(7, 9),
      toFinal = to.substr(7, 9);
  return (`${fromFinal}-${toFinal}`)
}


// WEBPACK FOOTER //
// ./src/utils/index.js